import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home/index.vue'
import product_society from '@/view/product/society/index.vue'
import product_manufacture from '@/view/product/manufacture/index.vue'
import product_manufacture_category from '@/view/product/manufacture/categoryDetail.vue'
import product_finance from '@/view/product/finance/index.vue'
import product_operationDecision from '@/view/product/operationDecision/index.vue'
import product_operationDecision_category from '@/view/product/operationDecision/categoryDetail.vue'
import product_digitization from '@/view/product/digitization/index.vue'
import product_architecture from '@/view/product/productArchitecture/index.vue'
import product_cognitive from '@/view/product/cognitive/index.vue'
import ecological_coreTechnology from '@/view/ecological/coreTechnology/index.vue'
import ecological_waic from '@/view/ecological/waic/index.vue'
import ecological_waic_detail from '@/view/ecological/waic/detail.vue'
import ecological_institute from '@/view/ecological/institute/index.vue'
import legalNotice from '@/view/otherFunction/legalNotice.vue'
import partner from '@/view/otherfunction/partner.vue'
import siteMap from '@/view/otherfunction/siteMap.vue'
import news from '@/view/news/index.vue'
import newsDetail from '@/view/news/detail.vue'
import about from '@/view/about/index.vue'
import addUs from '@/view/addUs/index.vue'
import { applyRouteMeta } from '@/utils/pageMeta'

Vue.use(Router)

// 把旧书签 /#/about 换成 /about，history 模式才能打开
if (typeof window !== 'undefined' && window.location.hash.indexOf('#/') === 0) {
  window.history.replaceState(null, '', window.location.hash.slice(1))
}


// //获取原型对象上的push函数
// const originalPush = Router.prototype.push
// //修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: home,
      meta: {
        menuactive: 0,
        title: '华院计算-认知智能算法平台与工业智能体',
        description: '华院计算技术（上海）股份有限公司从事认知智能技术研发，提供认知智能算法平台、工业级智能体与运营决策智能体，服务工业制造等行业。'
      }
    },
    {
      path: '/productSociety',
      name: 'product_society',
      component: product_society,
      meta: {
        title: '社会治理-华院计算',
        description: '依托认知智能引擎平台，构建基层治理的数字化产品平台，全面赋能基层智治、平安法治、产业发展、乡村振兴。'
      }
    },
    {
      path: '/productManufacture',
      name: 'product_manufacture',
      component: product_manufacture,
      meta: {
        title: '工业级智能体-华院计算',
        description: '基于认知智能算法平台，嵌入行业专属运营知识，专为复杂工业环境与长流程制造场景打造。产品覆盖制造全流程，支持智能控制、质量预测、运维监控与生产优化。'
      }
    },
    {
      path: '/productManufacture/category/:key',
      name: 'product_manufacture_category',
      component: product_manufacture_category,
    },
    {
      path: '/productFinance',
      name: 'product_finance',
      component: product_finance,
      meta: {
        title: '商业服务平台-华院计算',
        description: '依托认知智能引擎平台，围绕营销、风控、决策和客户体验升级，服务零售、金融等领域。'
      }
    },
    {
      path: '/operationDecision',
      name: 'product_operationDecision',
      component: product_operationDecision,
      meta: {
        title: '运营决策智能体-华院计算',
        description: '基于认知智能算法平台，嵌入企业营运流程，协助企业进行知识管理、数据分析、任务执行及营运决策。'
      }
    },
    {
      path: '/operationDecision/category/:key',
      name: 'product_operationDecision_category',
      component: product_operationDecision_category,
    },
    {
      path: '/productDigitization',
      name: 'product_digitization',
      component: product_digitization,
      meta: {
        title: 'AI4Science-华院计算',
        description: '华院计算在 AI4Science 方向开展新药研发、合成生物、医疗器械、再生医学辅助和大健康等创新。'
      }
    },
    {
      path: '/productArchitecture',
      name: 'product_architecture',
      component: product_architecture,
      meta: {
        title: '产品架构-华院计算',
        description: '华院计算以认知智能算法平台为底座，向上构建工业级智能体与运营决策智能体。'
      }
    },
    {
      path: '/productCognitive',
      name: 'product_cognitive',
      component: product_cognitive,
      meta: {
        title: '认知智能算法平台-华院计算',
        description: '认知智能算法平台构成技术架构的底层基础，统一整合计算资源、数据与算法模型，内置 20 万+ 算子及模型的标准化库。'
      }
    },
    {
      path: '/ecologicalCoreTechnology',
      name: 'ecological_coreTechnology',
      component: ecological_coreTechnology,
      meta: {
        title: '核心技术-华院计算',
        description: '华院计算认知智能核心技术与认知智能引擎。'
      }
    },
    {
      path: '/ecologicalWaic',
      name: 'ecological_waic',
      component: ecological_waic,
      meta: {
        asyncPrerender: true,
        title: '世界人工智能大会-华院计算',
        description: 'WAIC“认知智能，改变世界”分论坛由华院计算主办，推动认知智能的技术落地应用。'
      }
    },
    {
      path: '/ecologicalWaicDetail',
      name: 'ecological_waic_detail',
      component: ecological_waic_detail,
      meta: {
        title: '世界人工智能大会-华院计算',
        description: 'WAIC“认知智能，改变世界”分论坛由华院计算主办，推动认知智能的技术落地应用。'
      }
    },
    {
      path: '/ecologicalInstitute',
      name: 'ecological_institute',
      component: ecological_institute,
      meta: {
        title: '研究院-华院计算',
        description: '核心算法体系由斯梅尔数学与计算研究院与公司自研算法实验室共同驱动，将学术研究转化为可实际应用的算法。'
      }
    },
    {
      path: '/siteMap',
      name: 'siteMap',
      component: siteMap,
      meta: {
        title: '站点地图-华院计算',
        description: '华院计算移动站栏目导航。'
      }
    },
    {
      path: '/legalNotice',
      name: 'legalNotice',
      component: legalNotice,
      meta: {
        title: '法律声明-华院计算',
        description: '华院计算技术（上海）股份有限公司网站法律声明。'
      }
    },
    {
      path: '/partner',
      name: 'partner',
      component: partner,
      meta: {
        title: '合作伙伴-华院计算',
        description: '华院计算合作伙伴。'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        asyncPrerender: true,
        title: '华院新闻-华院计算',
        description: '华院计算新闻与活动。'
      }
    },
    {
      path: '/news/:id',
      name: 'newsDetail',
      component: newsDetail,
      meta: {
        asyncPrerender: true,
        title: '华院新闻-华院计算',
        description: '华院计算新闻详情。'
      }
    },
    {
      path: '/newsDetail',
      redirect: to => ({
        path: to.query.id ? '/news/' + to.query.id : '/news',
        query: {}
      })
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: '关于华院-华院计算',
        description: '华院计算技术（上海）股份有限公司是认知智能领域的开拓者，荣获国家级专精特新“小巨人”企业称号。'
      }
    },
    {
      path: '/addUs',
      name: 'addUs',
      component: addUs,
      meta: {
        title: '加入我们-华院计算',
        description: '加入华院计算。简历投递 hr@unidt.com。'
      }
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: addUs,
      meta: {
        canonical: '/addUs',
        title: '加入我们-华院计算',
        description: '加入华院计算。简历投递 hr@unidt.com。'
      }
    },
    {
      path: '*', // 页面不存在的情况下会跳到首页面
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  applyRouteMeta(to)
  document.documentElement.scrollTop = 0
  next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js